import styled from 'styled-components';
import Button from '../Button';
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from 'react-icons/ai';
import common from '../../styles/common';

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: ${({ isOpened }) => (isOpened ? 0 : '-390px')};
  transition: left 0.5s ease-out;
  height: 100%;
  max-height: 100%;
  width: 390px;
  max-width: 390px;
  min-width: 390px;
  padding-top: 15px;
  padding-bottom: 10px;
  background-color: white;
  z-index: 999;

  > h3,
  > div {
    padding-left: 20px;
  }

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const MenuIconBtn = styled(Button).attrs(({ isOpened }) => ({
  wrapperStyle: {
    width: '2.375rem',
    height: '2.375rem',
    top: 5,
    right: '-2.375rem',
    position: 'absolute',
    boxShadow: '0px 0px 15px 0px rgba(0, 0, 0, 0.1)',
  },
  type: 'rounded',
  icon: isOpened ? AiOutlineMenuFold : AiOutlineMenuUnfold,
  iconProps: {
    color: 'white',
    size: '1.5rem',
  },
}))``;

export const Title = styled.h3`
  margin-top: 0;
  margin-bottom: 10px;
`;

export const ProjectsWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  margin-bottom: 5%;
`;

export const NewProjectWrapper = styled.div`
  padding-right: 20px;
`;

export const NewProjectDesc = styled.p`
  font-size: 0.72rem;
  padding-left: 5px;
  padding-right: 10px;
  margin-bottom: 5px;
`;

export const NewProjectInputsWrapper = styled.div`
  > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const Input = styled.input`
  ${common.input}
`;

export const StartBtnWrapper = styled.div`
  margin-top: 15px;
`;
